import React from 'react'
import { Modal, Col, Row, Button } from 'react-bootstrap'
import * as Notifications from 'fw/globals/Notifications'
import { TextBox, RichTextEditor } from 'fw/forms'
import { Label } from 'fw/components'
import * as API from 'modules/app/API'

class EmailDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible,
            to: props.to,
            subject: props.subject,
            message: props.message
        };
    }

    componentWillReceiveProps(props, nextProps) {
        this.setState(
            {
                visible: props.visible,
                to: props.to,
                subject: props.subject,
                message: props.message,
                template: props.template
            });
    }

    close = () => {
        this.setState({ visible: false });
    }

    handleTextEditorChange = (e) => {
        this.setState({ message: e });
    }

    send = () => {
        let rq = {
            recipients: this.state.to,
            body: this.state.message,
            veteranOwnerId: this.props.veteranOwnerId
        }

        API.Biz.post('/vobSetup/sendConnectToVOBEmail', rq, {
            success: (r) => {
                this.close();
                Notifications.success(r.message);
            },
            error: (r) => {
                Notifications.error(r.error.errorMessage);
            }

        });
    }


    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Body>
                    <Row>
                        <Col md={2}><Label>To:</Label></Col>
                        <Col md={7}><TextBox value={this.state.to} readonly /></Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={2}><Label>Subject:</Label></Col>
                        <Col md={7}><TextBox value={this.state.subject} readonly /></Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={12}>
                            <RichTextEditor 
                            onChange={this.handleTextEditorChange}
                            enabled="enabled" name="default" value={this.state.message}
                            ref={(c) => { this._emailBody = c; }} />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close}>Cancel</Button>
                    <Button bsStyle="primary" onClick={this.send}>Send Email</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default EmailDialog;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/connectToVOB/EmailDialog.js